import React, { useEffect, useState } from "react";
import smallLogo from "../../Assets/Images/smallLogo.svg";
import logo from "../../Assets/Images/logo.svg";
import avatar from "../../Assets/Images/avatar.svg";
import { Bell, BellDot, LogOut, Menu, Settings } from "lucide-react";
import "./Navbar.scss";
import { useLocation, useNavigate } from "react-router-dom";
import NotificationPop from "Pages/Notifications/NotificationPop";
import { Popover, PopoverContent, PopoverTrigger } from "Components/ui/popover";
import { motion } from "framer-motion";
import UseInnerWidth from "hooks/UseInnerWidth";
import MenuSheet from "./NavbarComponents/MenuSheet";
import { useDispatch, useSelector } from "react-redux";
import { useAuth, useUser } from "@clerk/clerk-react";
import { getUser } from "../../Redux/Profile/ProfileActions";
import defaultProfile from "../../Assets/Images/default.webp";
import ThemeToggleButton from "Components/ThemeButton/ThemeButton";

function Navbar({ open, setOpen }) {
  const width = UseInnerWidth();
  // const { user } = useSelector((state) => state.ProfileReducer);
  const location = useLocation();

  const { getToken } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    if (getToken) {
      dispatch(getUser(getToken));
    }
  }, [getToken]);

  const { user } = useSelector((state) => state.ProfileReducer);


  const navigate = useNavigate();

  return (
    // <div className="flex flex-row gap-6 justify-between items-center w-full">
    //   {width < 769 &&
    //     (pathname.includes("/profile") ? (
    //       <MenuSheet
    //         data={[
    //           "Personal Information",
    //           "Account Information",
    //           "Security",
    //           "Identity",
    //           "Wallet",
    //         ]}
    //       />
    //     ) : pathname.includes("/challenge/") ? (
    //       <MenuSheet
    //         page="challenges"
    //         data={["Overview", "Rules", "Performance", "Trades"]}
    //       />
    //     ) : (
    //       <MenuSheet page="main" data={["Notifications", "Wallet"]} />
    //     ))}
    //   <img
    //     src={logo}
    //     alt="logo"
    //     onClick={() => navigate("/")}
    //     className={`w-[8rem] cursor-pointer `}
    //   />
    //   {width > 768 && (
    //     <motion.div
    //       className="p-2 flex gap-6 pr-8 flex-row items-center rounded-full bg-background-bottomNavbar relative border border-border-radio"
    //       animate={{
    //         opacity:
    //           pathname.includes("/profile") || pathname.includes("/challenge/")
    //             ? 0
    //             : 1,
    //         y:
    //           pathname.includes("/profile") || pathname.includes("/challenge/")
    //             ? -100
    //             : 0,
    //         display:
    //           pathname.includes("/profile") || pathname.includes("/challenge/")
    //             ? "none"
    //             : "flex",
    //       }}
    //       transition={{
    //         duration: 1,
    //       }}
    //     >
    //       {/* <img
    //       src={smallLogo}
    //       alt="Small Logo"
    //       className="absolute w-12 "
    //       style={{
    //         top: "0.1rem",
    //         left: "0rem",
    //       }}
    //     /> */}
    //       <div
    //         onClick={() => {
    //           navigate("/");
    //         }}
    //         className="text-sm select-none font-N_Roman bg-primary rounded-full px-10 cursor-pointer py-1"
    //       >
    //         Dashboard
    //       </div>
    //       <div
    //         className={`cursor-pointer  text-sm px-8 ${
    //           pathname.includes("/wallet")
    //             ? "text-primary"
    //             : "text-white-opacity"
    //         }`}
    //         onClick={() => navigate("/wallet")}
    //       >
    //         Wallet
    //       </div>
    //     </motion.div>
    //   )}

    //   <div className="flex gap-4 items-center">
    //     {width > 768 && (
    //       <>
    //         <NotificationPop />
    //         <Settings className="opacity-[0.3] cursor-pointer" />
    //       </>
    //     )}
    //     <motion.div
    //       className=" rounded-full w-[40px] h-[40px] overflow-hidden"
    //       onClick={() => {
    //         navigate("/profile");
    //       }}
    //       animate={{
    //         x: pathname.includes("/profile") ? 100 : 0,
    //         width: pathname.includes("/profile") ? 0 : "40px",
    //         height: pathname.includes("/profile") ? 0 : "40px",
    //       }}
    //       transition={{
    //         duration: 1,
    //       }}
    //     >
    //       <img
    //         src={user?.profile || defaultProfile}
    //         alt="avatar"
    //         className="cursor-pointer w-[40px] h-[40px]"
    //       />
    //     </motion.div>
    //   </div>
    // </div>
    <div className="bg-background h-[5.15rem] border-b-2 border-l-2 border-border-darkNew px-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        {width < 1024 && (
          <Menu
            className="cursor-pointer"
            onClick={() => {
              setOpen(!open);
            }}
            color="var(--white-opacity)"
          />
        )}
              <img src={user?.profile || defaultProfile} alt="Default" className="w-10 rounded-full h-10 aspect-square" />
        <div className="cursor-pointer" onClick={() => navigate("/profile")}>
          <div className="text-base text-baseColor font-N_Medium">
                    {user?.firstName ? user?.firstName + " " + user?.lastName : "-"}

          </div>
          <div className="text-sm text-white-opacity">Hello, Welcome Back!</div>
        </div>
      </div>
      <div className="flex items-center gap-6">
        <ThemeToggleButton />
        <div className="border-2 border-border-darkNew rounded-lg px-2 py-2 flex gap-4 items-center ">
          <NotificationPop />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
